import { Api } from '..'

export class ProductKeyApi extends Api {
  constructor(...args) {
    super(...args)
  }
  redeem(serial_code: string, skipError = true) {
    return this.createApi(
      '/v2/ProductKey/redeem',
      'post',
      {
        serial_code,
      },
      {
        skipError,
      }
    )
  }
}
